import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const CustomerPhoneCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Customer phone",
    cell: (row) => {
      return row.customerPhone ?? "";
    },
  };
